// extracted by mini-css-extract-plugin
export var externalLink = "_b9-0";
export var internalLinkLabel = "_b9-1";